<div
  *ngIf="unsyncedWarningMessage"
  class="padding-right-m padding-left-s info font-size-14 line-height-sm"
>
  <div class="font-bold-600 text-align-left">Action required</div>
  <div class="margin-top-xs text-align-left">
    {{ unsyncedWarningMessage }}
  </div>
</div>

<div
  [autosave-module]="saveopportunityDetailsModule"
  class="d-flex flex-column gap-m"
>
  <div class="detail-row d-flex flex-row justify-content-between">
    <div
      class="d-flex flex-column"
      *ngIf="
        permissionObj['Intake_OpportunityDetails_OpportunityNumber_Visible']
      "
    >
      <div class="eclipse-small-header-grey text-align-left">
        Opportunity ID:
      </div>
      <div
        class="eclipse-content text-align-left cursor-clickable green-color"
        (click)="onOpportunityNumberClick()"
      >
        <u>
          {{
            oportunityDetailsInfo.opportunityNumber
              ? oportunityDetailsInfo.opportunityNumber
              : defaultForEmptyFields
          }}
        </u>
      </div>
    </div>

    <div class="d-flex flex-column">
      <div class="eclipse-small-header-grey text-align-left">Stage:</div>
      <div class="eclipse-content text-align-left cursor-clickable">
        {{
          oportunityDetailsInfo.opportunityStatusName
            ? oportunityDetailsInfo.opportunityStatusName
            : defaultForEmptyFields
        }}
      </div>
    </div>
    <div
      class="d-flex flex-column"
      *ngIf="permissionObj['Intake_OpportunityDetails_LEP_Visible']"
    >
      <div class="eclipse-small-header-grey text-align-left">
        <span
          *ngIf="showRequiredIcon('leadEngagementPartner')"
          class="icon-required-yellow padding-left-sm"
        ></span>
        <span>Lead Engagement Partner:</span>
      </div>
      <div
        class="input-container text-align-left"
        (click)="$event.stopPropagation()"
      >
        <ng-container *ngIf="isEditingLEP; else displayLEP">
          <div class="col-12">
            <app-people-picker
              id="Lep-editor"
              [isTechinalReviewerSearch]="true"
              (userSelected)="onLepEngagementPartnerSelected($event)"
              [isLep]="true"
            />
          </div>
        </ng-container>
        <ng-template #displayLEP>
          <span class="title-value value-font">{{
            lepValue ? lepValue : defaultForEmptyFields
          }}</span>
          <span
            *ngIf="permissionObj['Intake_OpportunityDetails_LEP_Enable']"
            class="dds-icon dds-icon_edit__s__filled edit-icon"
            (click)="editLep()"
          ></span>
        </ng-template>
      </div>
      <div
        *ngIf="
          showJupiterLep &&
          permissionObj['Intake_Opportunity_FieldsOutOfSync_Visible']
        "
        class="eclipse-small-header-grey text-align-left"
      >
        Lead Engagement Partner in Jupiter: {{ originalLepValue }}
      </div>
    </div>
  </div>
  <div class="detail-row d-flex flex-row justify-content-between">
    <div
      class="d-flex flex-column"
      *ngIf="permissionObj['Intake_OpportunityDetails_StartDate_Visible']"
    >
      <div class="eclipse-small-header-grey text-align-left">
        <span
          *ngIf="showRequiredIcon('projectStartDate')"
          class="icon-required-yellow padding-left-sm"
        ></span>
        <span>Start date:</span>
      </div>
      <div
        class="input-container text-align-left"
        (click)="$event.stopPropagation()"
      >
        <ng-container *ngIf="isEditingStartDate; else displayStartDate">
          <div class="col-12">
            <dds-datepicker
              [size]="htmlElementSize"
              [placeholder]="datePickerOptions.placeholder ?? ''"
              [format]="datePickerOptions.format ?? ''"
              [minMode]="datePickerOptions.minMode ?? ''"
              [isResponsive]="datePickerOptions.isResponsive ?? false"
              [isManualInput]="datePickerOptions.isManualInput ?? false"
              [maxDate]="validStartDate"
              [(ngModel)]="tempStartDate"
              (ngModelChange)="onStartDateChanged()"
              id="StartDate-editor"
            >
            </dds-datepicker>
          </div>
        </ng-container>
        <ng-template #displayStartDate>
          <span class="title-value value-font">{{
            startDate ? startDate : defaultForEmptyFields
          }}</span>
          <span
            *ngIf="permissionObj['Intake_OpportunityDetails_StartDate_Enable']"
            class="dds-icon dds-icon_edit__s__filled edit-icon"
            (click)="editStartDate()"
          ></span>
        </ng-template>
      </div>
      <div
        *ngIf="
          showJupiterStartDate &&
          permissionObj['Intake_Opportunity_FieldsOutOfSync_Visible']
        "
      >
        <div class="eclipse-small-header-grey text-align-left">
          Start date in Jupiter: {{ originalStartDate }}
        </div>
      </div>
    </div>
    <div
      class="d-flex flex-column"
      *ngIf="permissionObj['Intake_OpportunityDetails_EndDate_Visible']"
    >
      <div class="eclipse-small-header-grey text-align-left">
        <span
          *ngIf="showRequiredIcon('projectEndDate')"
          class="icon-required-yellow padding-left-sm"
        ></span>
        <span>End date:</span>
      </div>
      <div
        class="input-container text-align-left"
        (click)="$event.stopPropagation()"
      >
        <ng-container *ngIf="isEditingEndDate; else displayEndDate">
          <div class="col-12">
            <dds-datepicker
              [size]="htmlElementSize"
              [placeholder]="datePickerOptions.placeholder ?? ''"
              [format]="datePickerOptions.format ?? ''"
              [minMode]="datePickerOptions.minMode ?? ''"
              [minDate]="validEndDate"
              [isResponsive]="datePickerOptions.isResponsive ?? false"
              [(ngModel)]="tempEndDate"
              (ngModelChange)="onEndDateChanged()"
              id="EndDate-editor"
            >
            </dds-datepicker>
          </div>
        </ng-container>
        <ng-template #displayEndDate>
          <span class="title-value value-font">{{
            endDate ? endDate : defaultForEmptyFields
          }}</span>
          <span
            *ngIf="permissionObj['Intake_OpportunityDetails_EndDate_Enable']"
            class="dds-icon dds-icon_edit__s__filled edit-icon"
            (click)="editEndDate()"
          ></span>
        </ng-template>
      </div>
      <div
        *ngIf="
          showJupiterEndDate &&
          permissionObj['Intake_Opportunity_FieldsOutOfSync_Visible']
        "
      >
        <div class="eclipse-small-header-grey text-align-left">
          End date in Jupiter: {{ originalEndDate }}
        </div>
      </div>
    </div>

    <div
      class="d-flex flex-column"
      *ngIf="permissionObj['Intake_OpportunityDetails_TotalFees_Visible']"
    >
      <div class="eclipse-small-header-grey text-align-left">
        <span
          *ngIf="showRequiredIcon('totalFees')"
          class="icon-required-yellow padding-left-sm"
        ></span>

        <span>Total fees $:</span>
      </div>
      <div
        class="input-container text-align-left"
        (click)="$event.stopPropagation()"
      >
        <ng-container *ngIf="isEditingTotalFees; else displayTotalFees">
          <div class="col-12">
            <dds-input
              [placeholder]="commonPlaceholder"
              [(ngModel)]="tempTotalFees"
              id="TotalFees-editor"
              (ngModelChange)="onTotalFeesChanged()"
            >
            </dds-input>
          </div>
        </ng-container>
        <ng-template #displayTotalFees>
          <span class="title-value value-font">{{
            totalFees ? totalFees : defaultForEmptyFields
          }}</span>
          <span
            *ngIf="permissionObj['Intake_OpportunityDetails_TotalFees_Enable']"
            class="dds-icon dds-icon_edit__s__filled edit-icon"
            (click)="editTotalFees()"
          ></span>
        </ng-template>
      </div>

      <div
        *ngIf="
          showJupiterTotalFees &&
          permissionObj['Intake_Opportunity_FieldsOutOfSync_Visible']
        "
      >
        <div class="eclipse-small-header-grey text-align-left">
          Total fees in Jupiter $: {{ originalTotalFees }}
        </div>
      </div>
    </div>
  </div>
  <div class="detail-row d-flex feetype-container">
    <div
      class="d-flex flex-column"
      *ngIf="permissionObj['Intake_OpportunityDetails_FeeType_Visible']"
    >
      <form [formGroup]="opportunityDetailsFeeForm">
        <div class="eclipse-small-header-grey text-align-left">
          <span
            *ngIf="showRequiredIcon('feeType')"
            class="icon-required-yellow padding-left-sm"
          ></span>
          <span>Fee type:</span>
        </div>
        <div *ngIf="reloadMultiSelect">
          <dds-multi-select
            autosave
            class="box-size multi-select-width"
            [disabled]="
              !permissionObj['Intake_OpportunityDetails_FeeType_Enable']
            "
            [isResponsive]="multiSelectOptions.isResponsive ?? false"
            [isRequired]="multiSelectOptions.isRequired ?? false"
            [label]="multiSelectOptions.label ?? emptyString"
            [size]="htmlElementSize"
            [placeholder]="multiSelectOptions.placeholder ?? emptyString"
            [type]="multiSelectOptions.type ?? emptyString"
            [controlType]="multiSelectOptions.controlType ?? emptyString"
            [theme]="multiSelectOptions.theme ?? emptyString"
            [isInverse]="multiSelectOptions.isInverse ?? false"
            [list]="multiselectFeeTypesOptions"
            [stickerIsDynamic]="false"
            (ngModelChange)="onMultiSelectValueChanged()"
            formControlName="feeType"
          >
          </dds-multi-select>
          <div
            *ngIf="
              permissionObj['Intake_Opportunity_FieldsOutOfSync_Visible'] &&
              showJupiterFeeType
            "
          >
            <div
              class="eclipse-small-header-grey text-align-left padding-top-xs"
            >
              Fee type in Jupiter:
              <span *ngIf="originalFeeTypes.length === 0">Not Available</span>
            </div>
            <ng-container *ngIf="originalFeeTypes.length !== 0">
              <div *ngFor="let feeType of originalFeeTypes">
                <div
                  class="text-align-left margin-top-fee-type eclipse-small-header-grey"
                >
                  {{ feeType?.feeTypeName }}
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </form>
    </div>
    <div class="d-flex flex-column multi-select-width">
      <ng-container
        *ngIf="
          this.opportunityDetailsFeeForm.get('feeType')?.value.length !== 0
        "
      >
        <span class="comments-text-label eclipse-small-header-grey"
          >Selected values:</span
        >
        <dds-tags>
          <dds-tag
            class="tag-width eclipse-header-grey"
            *ngFor="
              let item of this.opportunityDetailsFeeForm.get('feeType')?.value
            "
            [theme]="options.theme ?? emptyString"
            [isRemovable]="options.isRemovable ?? false"
            [disabled]="
              !permissionObj['Intake_OpportunityDetails_FeeType_Enable']
            "
            [customClass]="options.customClass ?? emptyString"
            [size]="htmlElementSize"
            [isError]="options.isError ?? false"
            [isInverse]="options.isInverse ?? false"
            (removed)="removeMultiSelectItemFeeType(item)"
            #tagItems
          >
            {{ item.label }}
          </dds-tag>
        </dds-tags>
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="
      permissionObj['Intake_OpportunityDetails_OpportunityDescription_Visible']
    "
    class="detail-row d-flex flex-row"
  >
    <div class="d-flex flex-column opportunity-description">
      <div class="eclipse-content text-align-left">
        <span
          *ngIf="isOpportunityDescriptionRequiredIconVisible()"
          class="icon-required-yellow"
        ></span
        >Provide opportunity description
      </div>
      <div class="textarea-container">
        <dds-textarea
          autosave
          name="opportunityDescription"
          [(ngModel)]="opportunityDescription"
          [label]="textareaOptions.label"
          [labelPosition]="textareaOptions.labelPosition"
          [placeholder]="textareaOptions.placeholder"
          [description]="textareaOptions.description"
          [minHeight]="textareaOptions.minHeight"
          [isRequired]="textareaOptions.isRequired"
          [customClass]="textareaOptions.customClass"
          [isError]="textareaOptions.isError"
          [errorMessage]="textareaOptions.errorMessage"
          [errorState]="textareaOptions.errorState"
          [maxLength]="textareaOptions.maxLength"
          [maxLengthPosition]="textareaOptions.maxLengthPosition"
          [size]="htmlElementSize"
          [readonly]="
            textareaOptions.readonly ||
            !permissionObj[
              'Intake_OpportunityDetails_OpportunityDescription_Enable'
            ]
          "
          (ngModelChange)="valueChanged()"
        ></dds-textarea>
      </div>
    </div>
    <div class="d-flex flex-column">
      <!-- Empty Placeholder -->
    </div>
  </div>
</div>
